import React from "react";
import { PageHero } from "../components/PageHero";
import { ServiceCards } from "../components/sections/ServiceCards";
import { WhatWeSolve } from "../components/sections/WhatWeSolve";
import { ContactCTA } from "../components/sections/ContactCTA";
import { useLang } from "../i18n/LanguageContext";

export default function Services() {
  const { t } = useLang();
  return (
    <>
      <PageHero
        overline={t({ en: "Services", no: "Tjenester" })}
        title={t({ en: "Software, AI and automation, built around your business.", no: "Programvare, AI og automatisering, bygget rundt din virksomhet." })}
        subtitle={t({
          en: "Four ways we help businesses build better technology — from custom software and websites to AI, automation, cloud and modernisation.",
          no: "Fire måter vi hjelper bedrifter med å bygge bedre teknologi — fra skreddersydd programvare og nettsider til AI, automatisering, sky og modernisering.",
        })}
      />
      <ServiceCards />
      <WhatWeSolve />
      <ContactCTA />
    </>
  );
}
